(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/mixins/socket-subscriber.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/mixins/socket-subscriber.js'); 
(function() {
  svs = svs || {};
  svs.statistics = svs.statistics || {};
  svs.statistics.mixins = svs.statistics.mixins || {};

  svs.statistics.mixins.SocketSubscriber = {
    subscribe: function(socketPath, callback, sendInitialUpdate) {
      var self;

      if (this._isSubscribed === true) {
        return; 
      }

      self = this;
      this._socketPath = socketPath; 
      this._listenerFn = callback;

      this.subscribeHandle = window.requestIdleCallback(function() {
        if (self._isSubscribed !== true) {
          svs.core.socket.subscribe(
            socketPath,
            self._listenerFn,
            self,
            sendInitialUpdate
          );
          self._isSubscribed = true;
        }
      });
    },

    unsubscribe: function() {
      var self;

      if (this._isSubscribed !== true) {
        if (this.subscribeHandle) {
          window.cancelIdleCallback(this.subscribeHandle);
          this.subscribeHandle = undefined;
        }
      } else {
        self = this;
        window.requestIdleCallback(function() {
          if (self._isSubscribed === true) {
            svs.core.socket.unsubscribe(self._socketPath, self._listenerFn);
            self._isSubscribed = false;
          }
        });
      }
    }
  };
})();

 })(window);